import Vue from 'vue'
import Guid from 'base/guid'
import { baseUrl, uat } from 'api/config'
import { isBroker, isToB, isWeCom } from 'base/config'

export function getUaString(ua) {
  let uaString
  if (ua === undefined) {
    uaString = navigator ? navigator.userAgent : ''
  } else {
    uaString = typeof ua !== 'string' ? '' : ua
  }
  return uaString
}

export function getUrlParam(name, url) {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]')
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)'),
    results = regex.exec(url ? url : location.search)

  return results === null
    ? ''
    : decodeURIComponent(results[1].replace(/\+/g, ' '))
}

export function setUrlParam(param, value, url) {
  var query = url ? url.split('?')[1] : location.search.substring(1)
  var urlPath = url ? url.split('?')[0] : location.origin + location.pathname
  var p = new RegExp('(^|)' + param + '=([^&]*)(|$)')
  if (p.test(query)) {
    var firstParam = query.split(param)[0]
    var secondParam = query.split(param)[1]
    if (secondParam.indexOf('&') > -1) {
      var lastPraam = secondParam.substring(secondParam.indexOf('&') + 1)
      return urlPath + '?' + firstParam + param + '=' + value + '&' + lastPraam
    } else {
      if (firstParam) {
        return urlPath + '?' + firstParam + param + '=' + value
      } else {
        return urlPath + '?' + param + '=' + value
      }
    }
  } else {
    if (query == '') {
      return urlPath + '?' + param + '=' + value
    } else {
      return urlPath + '?' + query + '&' + param + '=' + value
    }
  }
}

export function getUrlByAddingParam(map, url, cover) {
  var resultUrl, search, parems, urlPath
  if (url) {
    resultUrl = url
    urlPath = url.split('?')[0]
    parems = url.split('?')[1]
    search = parems ? '?' + parems : ''
  } else {
    resultUrl = location.href
    search = location.search
  }
  if (typeof map !== 'object') {
    return resultUrl
  }
  for (var name in map) {
    // 对已经有的参数不做覆盖
    if (map.hasOwnProperty(name) && !getUrlParam(name, url)) {
      var val = map[name]
      search += (search ? '&' : '?') + name + '=' + val
    } else if (cover) {
      var regex = new RegExp('([\\?&])(' + name + ')=([^&#]*)')
      search = search.replace(regex, '$1$2=' + map[name])
    }
  }

  if (cover && search.indexOf('?') < 0) {
    search = '?' + search
  }

  return url
    ? urlPath + search
    : location.origin + location.pathname + search + location.hash
}

export function getUrlByDeletingParam(map, url) {
  var resultUrl, search, parems, urlPath
  if (url) {
    resultUrl = url
    urlPath = url.split('?')[0]
    parems = url.split('?')[1]
    search = parems ? '?' + parems : ''
  } else {
    resultUrl = location.href
    urlPath = resultUrl.split('?')[0]
    search = location.search
  }
  if (typeof map !== 'object') {
    return resultUrl
  }

  var query = search.substr(1)

  var params = {}
  var arr = query.split('&')
  for (var i = 0; i < arr.length; i++) {
    arr[i] = arr[i].split('=')
    params[arr[i][0]] = arr[i][1]
  }

  for (var name in map) {
    if (map.hasOwnProperty(name) && params[name]) {
      delete params[name]
    }
  }

  var searchs = JSON.stringify(params)
    .replace(/[\"\{\}]/g, '')
    .replace(/\:/g, '=')
    .replace(/\,/g, '&')
  urlPath = searchs ? urlPath + '?' : urlPath

  return urlPath + searchs
}

export function loading(show, nomodal) {
  if (show) {
    if (window.appBridge && appBridge.showLoading) {
      appBridge.showLoading(
        !nomodal,
        (isToB || isWeCom) ? 3 : isBroker || getUrlParam('app') == 'Broker' ? 2 : 1
      )
    }
  } else {
    if (window.appBridge && appBridge.hideLoading) {
      appBridge.hideLoading()
    }
  }
}

export function loginApp() {
  if (window.appBridge && appBridge.checkAppFeature('APP_VIEW')) {
    appBridge.gotoAppView('login')
  } else if (isWeCom && window.WeCom && WeCom.gotoLogin) {
    WeCom.gotoLogin()
  } else {
    var requestUrl = encodeURIComponent(location.href)
    if (uat) {
      location.href =
        location.protocol +
        '//pbf-uat.winbaoxian.cn/planBook/tools/login/pages/login.html?requestUrl=' +
        requestUrl
    } else {
      location.href = baseUrl + '/user/login?requestUrl=' + requestUrl
    }
  }
}

export function isNullOrEmpty(value) {
  return !value || value.replace(/(^\s*)|(\s*$)/g, '') == ''
}

export function completeNumber(number) {
  number = parseInt(number)
  return number < 10 ? `0${number}` : number
}

export function sexToString(sex) {
  return sex === 1 ? '男' : '女'
}

export function buriedInit(
  { pageId, heartBeatRate, projectInfo } = {
    pageId: '',
    heartBeatRate: 100000,
    projectInfo: {}
  }
) {
  let host = window.location.hostname
  window.WeiyiStatSDK &&
    window.WeiyiStatSDK.init({
      pageId,
      isProduct: /com/.test(host) && /pbf/.test(host),
      heartBeatRate,
      projectInfo,
      // 以下参数为错误上报专用参数
      Vue, // 可选, 也可前置 window.Vue = Vue 来代替
      name: process.env.PKG_NAME, // 必选, package.json 中的 name
      version: process.env.PKG_VERSION // 必选, package.json 中的 version
    })
}

export function buriedSubmit(id, ep) {
  if (!window.WeiyiStatSDK || !window.WeiyiStatSDK.submit || !id) return
  try {
    window.WeiyiStatSDK.submit(id, ep || null)
  } catch (error) {
    console.log('[ERROR][WeiyiStatSDK]', error)
  }
}

export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (time === null) {
    return
  } else if (typeof time === 'object') {
    date = time
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    if (key === 'a') {
      return ['一', '二', '三', '四', '五', '六', '日'][value - 1]
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

let positionTop = 0
export function stopBodyScroll(isFixed) {
  let bodyEl = document.body
  if (isFixed) {
    positionTop = window.scrollY
    bodyEl.style.position = 'fixed'
    bodyEl.style.top = -positionTop + 'px'
    bodyEl.style.width = '100%'
    document.documentElement.style.height = window.innerHeight + 'px'
  } else {
    bodyEl.style.position = ''
    bodyEl.style.top = ''
    bodyEl.style.width = ''
    document.documentElement.style.height = ''
    window.scrollTo(0, positionTop)
  }
}

export function throttle(func, wait, options) {
  var context, args, result
  var timeout = null
  // 上次执行时间点
  var previous = 0
  if (!options) options = {}
  // 延迟执行函数
  var later = function () {
    // 若设定了开始边界不执行选项，上次执行时间始终为0
    previous = options.leading === false ? 0 : +new Date()
    timeout = null
    result = func.apply(context, args)
    if (!timeout) context = args = null
  }
  return function () {
    var now = +new Date()
    // 首次执行时，如果设定了开始边界不执行选项，将上次执行时间设定为当前时间。
    if (!previous && options.leading === false) previous = now
    // 延迟执行时间间隔
    var remaining = wait - (now - previous)
    context = this
    args = arguments
    // 延迟时间间隔remaining小于等于0，表示上次执行至此所间隔时间已经超过一个时间窗口
    // remaining大于时间窗口wait，表示客户端系统时间被调整过
    if (remaining <= 0 || remaining > wait) {
      clearTimeout(timeout)
      timeout = null
      previous = now
      result = func.apply(context, args)
      if (!timeout) context = args = null
      //如果延迟执行不存在，且没有设定结尾边界不执行选项
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(later, remaining)
    }
    return result
  }
}

export function debounce(func, wait, immediate) {
  var timeout, args, context, timestamp, result
  var later = function () {
    // 据上一次触发时间间隔
    var last = +new Date() - timestamp
    // 上次被包装函数被调用时间间隔last小于设定时间间隔wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function () {
    context = this
    args = arguments
    timestamp = +new Date()
    var callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }
    return result
  }
}

export function getLocalStorage(key, token) {
  var nowTime = +new Date()
  var lc_params = localStorage && localStorage.getItem(key)
  lc_params = lc_params && JSON.parse(lc_params)
  if (lc_params && !lc_params.token) {
    lc_params.token = token
  }
  if (lc_params && lc_params.token === token && lc_params.expires > nowTime) {
    return lc_params.data
  } else {
    return null
  }
}

export function setLocalStorage(key, value, expires_time, token) {
  var nowTime = +new Date()
  var lc_params = {
    data: value,
    token: token,
    expires: nowTime + expires_time
  }

  localStorage && localStorage.setItem(key, JSON.stringify(lc_params))
}

export function getAppVersion() {
  let appMatches
  const uaString = navigator.userAgent
  appMatches = /WeiYi\/(\d{1,}(\.\d{1,})+)\b/i.exec(uaString)
  if (!!appMatches && appMatches[1]) {
    return appMatches[1]
  }
  appMatches = /WYINS\/(\d{1,}(\.\d{1,})+)\b/i.exec(uaString)
  if (!!appMatches && appMatches[1]) {
    return appMatches[1]
  }
  return ''
}

export function compareVersion(strVer, strCompareVer) {
  if (!strVer) return
  if (strVer == strCompareVer) {
    return '='
  }
  var currArr = strVer.split('.')
  var targetArr = strCompareVer.split('.')
  var len =
    currArr.length >= targetArr.length ? currArr.length : targetArr.length

  for (var i = 0; i < len; i++) {
    if (!currArr[i]) {
      currArr[i] = 0
    }
    if (!targetArr[i]) {
      targetArr[i] = 0
    }

    if (currArr[i] > targetArr[i]) {
      return '>'
    } else if (currArr[i] < targetArr[i]) {
      return '<'
    }
  }

  return '='
}

export function getToken(tokenKey, timestampKey) {
  let _token = getUrlParam('token')
  if (isNullOrEmpty(_token)) {
    let now = new Date().getTime()
    let old = localStorage.getItem(timestampKey)
    if (now - old >= 60 * 60 * 1000) {
      localStorage.removeItem(tokenKey)
    }
    _token = localStorage.getItem(tokenKey)
    if (isNullOrEmpty(_token)) {
      _token = Guid.create()
      localStorage.setItem(tokenKey, _token)
      localStorage.setItem(timestampKey, new Date().getTime())
    }
  } else {
    localStorage.setItem(tokenKey, _token)
    localStorage.setItem(timestampKey, new Date().getTime())
  }

  return _token
}
